<template>
    <form action="" method="post" enctype="multipart/form-data" class="sinature_load mt-4">
        <input type="file" name="files" ref="file" class="files" :data-fileuploader-files='preloadedfiles' />
    </form>
</template>

<script>
export default {
    props: ['preloadedfiles', 'uuidOffer'],
    data() {
        return {
            file: null,
        }
    },
    methods: {
        sendData() {
            this.$emit('data', this.file);
        },
        initUploader() {
            var t = this
            $(document).ready(function () {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                    }
                });
                $(".sinature_load input.files").fileuploader({
                    limit: 1,
                    extensions: ["jpg", "png", "svg"],
                    fileMaxSize: 2,
                    changeInput:
                        '<div class="fileuploader-input">' +
                        '<span class="top_left">pečiatka / Podpis</span>' +
                        '<div class="fileuploader-input-inner">' +
                        '<div class="fileuploader-icon-main"></div>' +
                        '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                        "<p>${captions.or}</p>" +
                        "</div>" +
                        "</div>",
                    theme: "dragdrop",
                    thumbnails: {
                        onImageLoaded: function (item) {
                            t.file = item
                            if (!item.html.find(".fileuploader-action-edit").length)
                                item.html
                                    .find(".fileuploader-action-remove")
                                    .before(
                                        '<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Uraviť">' +
                                        '<i class="fileuploader-icon-edit"></i></button>'
                                    );

                            // hide current thumbnail (this is only animation)
                            if (item.imageIsUploading) {
                                item.image.addClass("fileuploader-loading").html("");
                            }
                            t.sendData()
                        },
                    },
                    editor: {
                        cropper: {
                            showGrid: true
                        }
                    },
                    captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                        feedback: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím alebo <span class='nahraj'>nahraj podpis</span>",
                        feedback2: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím alebo <span class='nahraj'>nahraj podpis</span>",
                        drop: "Vlož <b>podpis</b> alebo <b>pečiatku</b> presunutím alebo <span class='nahraj'>nahraj podpis</span>",
                        or: "",
                        button: "",
                        remove: "Vymazať",
                        download: "Stiahnuť",
                        removeConfirmation: "Naozaj chcete vymazať podpis?",
                        errors: {
                            filesLimit: function (e) {
                                t.$toast.warning("Je možné nahrať len jeden podpis. Prosím, najskôr vymažte pôvodné.", {
                                    timeout: 5000,
                                })
                            },
                            filesType: function (e) {
                                t.$toast.warning("Iba " + e.extensions + " soubory môžu byť nahranté.", {
                                    timeout: 5000,
                                })
                            },
                            fileSize: function (e) {
                                t.$toast.warning(e.name + " je príliš velký! Prosím, výberte soubor do velikosti " + e.fileMaxSize + " MB.", {
                                    timeout: 5000,
                                })
                            }
                        }
                    }),
                    onRemove: function (item) {
                        t.file = null
                        axios.post('/api/offers/offer/signature/remove', { uuid: t.uuidOffer }).then(response => {
                            t.$toast.success("Pečiatka/podpis bol odstránený.", {
                                timeout: 2038,
                            });
                        })
                        t.sendData()
                    },

                });
            })
        }
    },
    mounted() {
        this.initUploader()
    },
}

</script>

<style lang="scss">
.sinature_load {
    .fileuploader {
        background: transparent;
        margin: 0;
        padding: 0;
    }

    .fileuploader-theme-dragdrop .fileuploader-input {
        position: relative;
        border: 1px dashed #DDE3E8;
        padding: 15px;
        height: 91px;

        @media (max-width: 600px) {
            height: 110px !important;

            .fileuploader-input-caption {
                flex: 1 !important;
            }
        }

        .top_left {
            position: absolute;
            left: 15px;
            top: 15px;
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 11px;
            line-height: 13px;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #9598A7;
        }

        .fileuploader-input-inner {
            margin-top: 14px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }

    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-icon-main {
        margin: 0;
        font-size: 32px;
    }

    h3.fileuploader-input-caption {
        margin: 0;
        display: block;
        flex: none;
        align-self: center;
        margin-left: 10px;
        font-family: Roboto;
        font-style: normal;
        font-size: 14px;
        line-height: 16px;

        span {
            font-weight: normal;
            color: #263544;
        }

        .nahraj {
            font-weight: 600;
            color: #2ED8B6;
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss" scoped>
form {
    width: 100%;
    margin: 0 auto;

    @media only screen and (max-width: 600px) {
        width: 95%;
    }
}
</style>